export default __webpack_public_path__ + "static/media/icon-profit.439db9fd.svg";